module.exports = __webpack_public_path__ + "public/SiteIcons/minusIncrement.svg?5a249aaa";